import { render, staticRenderFns } from "./MethodSurveyComponent.vue?vue&type=template&id=76b0ef73&scoped=true"
import script from "./MethodSurveyComponent.vue?vue&type=script&lang=js"
export * from "./MethodSurveyComponent.vue?vue&type=script&lang=js"
import style0 from "./MethodSurveyComponent.vue?vue&type=style&index=0&id=76b0ef73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b0ef73",
  null
  
)

export default component.exports